import MuiAlert from "@mui/lab/Alert";
import { Snackbar, SnackbarCloseReason } from "@mui/material";
import { ReactNode, SyntheticEvent, useEffect, useState } from "react";

interface Props {
	message: string | null;
	onHide: () => void;
	severity?: "error" | "info" | "success" | "warning";
	// null keeps it open
	autoHideDuration?: number | null;
	action?: ReactNode;
}

export const NotificationSnackBar = ({
	message,
	onHide = () => {},
	severity = "success",
	autoHideDuration = 2500,
	action,
}: Props) => {
	const handleClose = (
		event?: SyntheticEvent | Event,
		reason?: SnackbarCloseReason,
	) => {
		if (reason === "clickaway") {
			return;
		}
		onHide();
	};
	const [open, setOpen] = useState(true);
	useEffect(() => {
		setOpen(!!message);
	}, [message]);

	return (
		<Snackbar
			open={open}
			autoHideDuration={autoHideDuration}
			onClose={handleClose}
			anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
		>
			<MuiAlert
				elevation={6}
				variant="filled"
				severity={severity}
				onClose={handleClose}
				action={action}
			>
				{message}
			</MuiAlert>
		</Snackbar>
	);
};
